import React from 'react';
import PageShell from '../components/PageShell';
import PageSection from '../components/page/PageSection';
import SituationCard from '../components/situations/SituationCard';
import SituationsCta from '../components/situations/SituationsCta';
import { situations } from '../content/pages';
import { SITE } from '../components/Seo';

/**
 * «З чого почати» — окрема сторінка.
 *
 * Це був другий розділ головної, одразу перед «Нашими послугами», і власник
 * зауважив головне: два розділи не відрізнялися ні структурою, ні змістом.
 * Справді — шість карток із малюнком, назвою, абзацом і посиланням, і в обох
 * випадках вони вели на ті самі сторінки послуг. Різниця була тільки в куті
 * зору, а на вигляд це читалося як один блок, зроблений двічі.
 *
 * Тепер це сторінка. Кут зору від того не зникає: людина, яка шукає «що
 * робити після відмови в ліцензії», приходить у пошуку не за назвою послуги —
 * і тепер має куди прийти.
 *
 * Картки — перше під банером: заради вибору своєї ситуації сюди й
 * приходять. Раніше до них було два абзаци вступу й фото на пів екрана, і
 * на ноутбуці перша картка опинялася нижче краю екрана. Другий абзац
 * («нижче не перелік того, що ми продаємо, а перелік того, що вже сталося у
 * вас») тепер і є заголовком розділу.
 */
const intro =
  'Питання до юриста рідко починається з назви послуги. Людина приходить із тим, що вже сталося: відмовили в ліцензії, минув строк подання Відомостей, прийшла перевірка, лікар виходить із найму й не знає, з чого починати власну практику. Кожна ситуація нижче веде на сторінку, де вона розібрана до кроків.';

const SituationsPage = () => {
  const listSchema = {
    '@type': 'ItemList',
    name: 'Ситуації, з якими звертаються до юриста з медичного права',
    itemListElement: situations.map((s, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: s.title,
      description: s.text,
      url: SITE + s.to
    }))
  };

  return (
    <PageShell
      title="З чого почати: типові ситуації клінік"
      description="Відмова в ліцензії, не подані Відомості за Постановою № 781, перевірка контролюючого органу, відкриття клініки з нуля — що робити в кожній із цих ситуацій."
      path="/z-chogo-pochaty"
      banner="/images/page-corridor-0c1de303.jpg"
      schema={listSchema}
      crumbs={[{ name: 'З чого почати' }]}
      heading="З чого почати"
      lead="Ситуації, з якими до нас звертаються найчастіше, і те, з чого варто починати в кожній із них."
      cta={false}
    >
      {/* Заклик у кінці — свій (SituationsCta), тож відступ до підвалу тут. */}
      <div className="page-container pt-10 lg:pt-14 pb-16 lg:pb-24">
        <PageSection
          id="situations"
          caption="Оберіть свою ситуацію"
          title="Що вже сталося у вас?"
          description={intro}
        >
          <ul className="list-none grid gap-4 md:grid-cols-2 xl:grid-cols-3 lg:gap-6">
            {situations.map((situation, index) => (
              <SituationCard key={situation.title} situation={situation} index={index} />
            ))}
          </ul>
        </PageSection>

        {/* Відступ той самий, що від останнього розділу до заклику
            PageShell на інших сторінках (py-10 lg:py-14 контейнера). */}
        <SituationsCta className="mt-10 lg:mt-14" />
      </div>
    </PageShell>
  );
};

export default SituationsPage;
